<template>
  <div>
    <div v-if="!refundSuccess">
      <div
        style="width:100%;height:158px;background-color:#fff;display: flex;justify-content:center"
      >
        <div class="top-center">
          <div class="icon">
            <van-icon name="todo-list-o" size="34" />
          </div>
          <div class="price">申请退款￥{{ couponInfo.couponPrice }}</div>
          <div class="explain">提货卡状态将更改为待激活</div>
        </div>
      </div>
      <van-cell-group style="margin-top:7px">
        <van-cell
          title="卡券编码"
          :value="couponInfo.couponCode"
          title-style="flex:none"
          value-class="cell-value"
        ></van-cell>
        <van-cell
          title="指定商品"
          :value="couponInfo.designatedGoods"
          title-style="flex:none"
          value-class="cell-value"
        ></van-cell>
        <van-cell
          title="卡券日期"
          :value="couponInfo.startTime + '-' + couponInfo.endTime"
          title-style="flex:none"
          value-class="cell-value"
        ></van-cell>
        <van-cell
          title="激活时间"
          :value="couponInfo.activationTime"
          title-style="flex:none"
          value-class="cell-value"
        ></van-cell>
        <van-cell
          title="退款金额"
          :value="couponInfo.couponPrice"
          title-style="flex:none"
          value-class="cell-value"
        ></van-cell>
      </van-cell-group>
      <van-button
        color="#c6a560"
        style="width:194px;height: 44px;margin-top:20px;left:50%;transform:translateX(-50%)"
        @click="refund"
        >确认申请</van-button
      >
    </div>
    <div v-else>
      <div
        style="width:100%;height: 184px;background-color:#fff;display:flex;justify-content:center;align-items:center;flex-direction: column"
      >
        <div class="icon">
          <van-icon name="checked" size="42" color="#13990F" />
        </div>
        <div
          style="font-size: 18px;text-align: center;font-family: PingFangSC-regular;color:#13990F;margin-top:17px"
        >
          提交成功
        </div>
        <div
          style="margin-top:14px;font-size: 14px;text-align: center;font-family: PingFangSC-regular;"
        >
          申请退款￥{{ couponInfo.couponPrice }}
        </div>
        <div class="explain">工作人员将在三个工作日内为您审核</div>
      </div>
      <van-button
        style="width:80px;height: 30px;margin-top:20px;left:50%;transform:translateX(-50%)"
        @click="backToList"
        >返回</van-button
      >
    </div>
  </div>
</template>

<script>
import { queryPost } from "@/api/common";
import { Toast, Dialog } from "vant";
export default {
  data() {
    return {
      couponInfo: this.$route.query,
      refundSuccess: false
    };
  },
  methods: {
    refund() {
      Dialog.confirm({
        message: "确认申请退款？"
      })
        .then(() => {
          let url = "/order/couponBusiness/couponRefund";
          let params = {
            couponId: this.couponInfo.id
          };
          queryPost(url, params).then(res => {
            if (res.data.code === "0000") {
              Toast.success("提交成功");
              this.refundSuccess = true;
            } else {
              Toast.fail(res.data.msg);
            }
          });
        })
        .catch(() => {
          Toast.fail("已取消");
        });
    },
    backToList() {
      this.$router.replace({ path: "/couponList", query: {} });
    }
  }
};
</script>

<style lang="less" scoped>
.top-center {
  justify-content: center;
  display: flex;
  flex-direction: column;
}
.icon {
  text-align: center;
}
.price {
  text-align: center;
  font-size: 18px;
  font-family: PingFangSC-regular;
  color: #c6a560;
  margin-top: 25px;
}
.explain {
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-regular;
  margin-top: 9px;
}
.cell-value {
  text-align: left;
  margin-left: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>
